module.exports = __webpack_public_path__ + "img/icon-user-2.ed7ad280.svg";